import React from 'react';
import { LOGO } from '../media';
import { CONTACT_EMAIL } from '../content';
export function SiteFooter() {
  return <footer className="theme-dark border-t border-border bg-background text-foreground" data-id="element-80" data-mp="3r9kgr78jdz70">
      <div className="section-shell flex flex-col gap-8 py-12 md:flex-row md:items-end md:justify-between" data-id="element-81" data-mp="3mghlmuo42hop">
        <div data-id="element-82" data-mp="3hhohhsups317">
          <img src={LOGO} alt="Vitality Foundation" className="h-14 w-auto max-w-52 object-contain" data-id="element-83" data-mp="3hhwstgb6v0aa" />
          <p className="mt-5 max-w-sm text-body-sm leading-body text-muted-foreground" data-id="element-84" data-mp="3di5y51ijk00h">
            Supporting founders across air, water, food, health, and materials.
          </p>
        </div>

        <div className="text-body-sm text-muted-foreground md:text-right" data-id="element-85" data-mp="33j6vq0odd0lx">
          <address className="not-italic" data-id="element-86" data-mp="2ykna61dotqu3">
            Vitality Foundation &middot; Denver, CO &middot;{' '}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-accent-text hover:underline" data-id="element-87" data-mp="11q0p8aqnayoq">
              {CONTACT_EMAIL}
            </a>
          </address>
          <p className="mt-2 text-caption" data-id="element-88" data-mp="15r4zcqu3ywmh">&copy; 2026 Vitality Foundation</p>
        </div>
      </div>
    </footer>;
}